import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { IInvitationDialogData } from '@modeso/aumico-lib-core-fe';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'invite-user',
    templateUrl: './invite-user.component.html',
    styleUrls: ['./invite-user.component.scss'],
})
export class InviteUserComponent implements OnInit, OnDestroy {
    @Input() dialogData: IInvitationDialogData;
    @Input() ownEmail: string;
    emailFormControl = new UntypedFormControl('', [Validators.email]);
    emailChips: string[] = [];
    @Output() emitEmails = new EventEmitter<string[]>();
    @Output() emitPreparedEmail = new EventEmitter<string | null>();

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.emailFormControl.valueChanges
            .pipe(debounceTime(400), distinctUntilChanged(), takeUntil(this.destroy$))
            .subscribe((value: string) => {
                const email = value?.trim().toLowerCase();
                if (this.emailFormControl.valid && email) {
                    if (!this.emailChips.includes(email) && email !== this.ownEmail) {
                        this.emitPreparedEmail.emit(email);
                    } else {
                        this.emitPreparedEmail.emit(null);
                    }
                } else {
                    this.emitPreparedEmail.emit(null);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onKeyPress(): void {
        const emailValue = this.emailFormControl.value?.trim().toLowerCase();

        if (
            emailValue &&
            this.emailFormControl.valid &&
            !this.emailChips.includes(emailValue) &&
            emailValue !== this.ownEmail
        ) {
            this.emailChips.push(emailValue);
            this.emitEmails.emit(this.emailChips);
            this.emailFormControl.reset();
        }
    }

    onRemoveEmail(index: number): void {
        this.emailChips.splice(index, 1);
        this.emitEmails.emit(this.emailChips);
    }
}
